import { graphql, useStaticQuery } from 'gatsby';
import { BlogPageQuery, BlogPagePreview } from './blogQueries';

export const useSupport = (): BlogPagePreview[] => {
    const supportPagePreviews: BlogPageQuery = useStaticQuery(graphql`
        {
            allKontentItemLayoutMasterPage(
                filter: {
                    elements: {
                        page_type: {
                            value: {
                                elemMatch: { codename: { eq: "support" } }
                            }
                        }
                    }
                    system: { workflow_step: { ne: "archived" } }
                }
                sort: { system: { last_modified: DESC } }
            ) {
                nodes {
                    ...blogPagePreview
                    elements {
                        page_components {
                            value {
                                __typename
                                ... on kontent_item_component___product_support_layout {
                                    system {
                                        type
                                    }
                                    elements {
                                        product_0acaef2 {
                                            value {
                                                ... on kontent_item_layout___master_page {
                                                    elements {
                                                        slug {
                                                            value
                                                            url
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    `);

    return supportPagePreviews.allKontentItemLayoutMasterPage.nodes;
};
